export const BASE_CATEGORIES = ["Électricité", "Plomberie", "Meubles", "Décoration"];

export const orderedCategories = (products) => {
  const found = [...new Set(products.map((p) => p.category).filter(Boolean))];
  return [
    ...BASE_CATEGORIES.filter((c) => found.includes(c)),
    ...found.filter((c) => !BASE_CATEGORIES.includes(c)).sort(),
  ];
};

export const catSlug = (s) =>
  s.toLowerCase().replace(/\s/g, "-").normalize("NFD").replace(/[̀-ͯ]/g, "");

// Descriptions éditoriales par catégorie — affichées dans la boutique et pensées pour Google Sénégal
export const CATEGORY_SEO = {
  "Électricité":
    "Luminaires et solutions électriques design pour votre intérieur à Dakar et partout au Sénégal : suspensions, appliques et éclairages choisis avec soin pour une maison moderne.",
  "Plomberie":
    "Robinetterie et mitigeurs haut de gamme pour votre cuisine équipée au Sénégal et votre salle de bain : finitions or, noir mat et inox, livrés à Dakar et dans toutes les régions.",
  "Meubles":
    "Meubles de salle de bain modernes à Dakar : meubles vasque, meubles de douche et rangements élégants pour aménager une salle de bain digne d'un showroom.",
  "Décoration":
    "Miroirs, accessoires et décoration d'intérieur pour sublimer votre maison au Sénégal — des pièces choisies qui racontent votre style.",
  "Lits coffres":
    "Lits coffres et mobilier de chambre à coucher au Sénégal : rangements malins intégrés, matelas et sommiers confortables, livrés à Dakar, Thiès, Mbour et Saint-Louis.",
};
